import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateAccountLegacyId as UpdateAccountLegacyIdMutation,
    UpdateAccountLegacyIdVariables,
} from 'nutshell-graphql-types';

import UPDATE_ACCOUNT_LEGACY_ID from '../mutations/update-account-legacy-id.graphql';

export function useUpdateAccountLegacyId(): {
    updateAccountLegacyId: (accountId: string, legacyId: string | null) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [updateAccountLegacyId, {loading, error}] = useMutation<
        UpdateAccountLegacyIdMutation,
        UpdateAccountLegacyIdVariables
    >(UPDATE_ACCOUNT_LEGACY_ID);

    return {
        updateAccountLegacyId: (accountId: string, legacyId: string | null) =>
            updateAccountLegacyId({
                variables: {input: {accountId, legacyId}},
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
